// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper-form[data-v-87b74870] {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1rem/* 16px */;\n  padding-top: 0.5rem/* 8px */;\n  padding-bottom: 0.5rem/* 8px */;\n}\n.col-span-3[data-v-87b74870] {\n  grid-column: span 3 / span 3;\n}\n.col-span-2[data-v-87b74870] {\n  grid-column: span 2 / span 2;\n}\n.col-span-1[data-v-87b74870] {\n  grid-column: span 1 / span 1;\n}\n\n", ""]);
// Exports
module.exports = exports;
